import React from 'react';
import { DayPilotMonth, DayPilotCalendar } from "daypilot-pro-react";

class Calendar extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { viewType, ...rest } = this.props;
    const ViewComponent = viewType == "Month" ? DayPilotMonth : DayPilotCalendar;

    return (
      <ViewComponent
        {...rest}
        viewType={viewType}
        ref={component => {
          this.calendar = component && component.control;
        }}
      />
    );
  }
}

Calendar.defaultProps = {
  viewType: "Month"
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/calendar/index.js